import NavigationTabsBilling from './Billing';
import NavigationTabsClient from './Client';
import NavigationTabsDocumentSettings from './DocumentSettings';
import NavigationTabsHistory from './History';
import NavigationTabsPartnerOverview from './Partner';
import NavigationTabsPortal from './Portal';
import NavigationTabsTeam from './Team';
import NavigationTabsTeamMember from './Team/Member';

const NavigationTabs = {
    Billing: NavigationTabsBilling,
    Client: NavigationTabsClient,
    DocumentSettings: NavigationTabsDocumentSettings,
    History: NavigationTabsHistory,
    Partner: NavigationTabsPartnerOverview,
    Portal: NavigationTabsPortal,
    Team: NavigationTabsTeam,
    TeamMember: NavigationTabsTeamMember,
};

export default NavigationTabs;
